<template>
  <div>
    <a-comment v-for="comment in comments" :key="comment.id">
      <!-- <a-tag v-if="comment.autoReply ===1">{{ "自动回复" }}</a-tag> -->
      <!-- <span v-if="comment.msg.message">「{{ comment.msg.message }}」</span> -->
      <a v-if="comment.from === 0" slot="author">{{ comment.staffName + '  回复于:' }}</a>
      <a v-if="comment.from === 1" slot="author">{{ comment.userName + '  回复于:' }}</a>
      <!-- <a-avatar slot="avatar" :src="comment.creator.avatar_url" /> -->
      <a slot="datetime">{{ transferTime(comment.time) }}</a>
      <p v-if="comment.msg.includes('note')" slot="content">
        {{ JSON.parse(comment.msg).note }}
      </p>
      <p v-else-if="comment.msg.includes('jpg') || comment.msg.includes('png')" slot="content">
        <a-upload action="https://www.mocky.io/v2/5cc8019d300000980a055e76" list-type="picture-card" :file-list="convertImageList([JSON.parse(comment.msg).url])" @preview="handlePreview" />
      </p>
      <p v-else-if="comment.msg.message != null" slot="content">
        {{ comment.msg.message }}
      </p>
      <p v-else-if="comment.msg.content != null" slot="content">
        {{ comment.msg.content }}
      </p>
      <p v-else slot="content">
        {{ comment.msg }}
      </p>
    </a-comment>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import Lightbox from 'vue-pure-lightbox';
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  props: {
    connectionList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      comments: []
    };
  },

  mounted() {
    this.comments = this.connectionList || [];
    this.comments.reverse();
  },
  methods: {
    convertImageList(imageList) {
      return imageList.map((url, index) => ({
        uid: `-${index + 1}`,
        name: 'image.png',
        status: 'done',
        url: url
      }));
    },
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    transferTime(timestamp) {
      var date = new Date(timestamp);
      var formattedTime = date.toLocaleString();
      return formattedTime;
    }
  }
};
</script>

<style lang="less" scoped></style>
